export const DEADLINE_BUCKETS = ['EXPIRED', 'EXPIRING', 'OK', 'NO_DEADLINE', 'IN_RENEWAL'] as const;
export type DeadlineBucket = (typeof DEADLINE_BUCKETS)[number];

export const DEADLINE_MANAGED_BY_VALUES = ['CLIENT', 'CONSULTANT'] as const;
export type DeadlineManagedByValue = (typeof DEADLINE_MANAGED_BY_VALUES)[number];

export const DEADLINE_DOMAIN_VALUES = ['FOOD_SAFETY', 'WORKPLACE_SAFETY', 'LEGAL'] as const;
export type DeadlineDomainValue = (typeof DEADLINE_DOMAIN_VALUES)[number];
/** Righe senza tipo di catalogo (titolo libero) o con tipo senza dominio. */
export const DEFAULT_DEADLINE_DOMAIN: DeadlineDomainValue = 'FOOD_SAFETY';

export const DEADLINE_CYCLE_KIND_VALUES = [
  'CREATED',
  'RENEWAL',
  'DATE_CHANGED',
  'TAKEN_OVER',
  'TAKEOVER_EXPIRED',
  'TAKEOVER_CANCELLED',
  'MANAGEMENT_CHANGED',
  'ARCHIVED',
  'RESTORED',
  'DELETED',
] as const;
export type DeadlineCycleKindValue = (typeof DEADLINE_CYCLE_KIND_VALUES)[number];

export const DEADLINE_STEP_KIND_VALUES = ['WARNING', 'DUE', 'OVERDUE'] as const;
export type DeadlineStepKindValue = (typeof DEADLINE_STEP_KIND_VALUES)[number];

export const RECURRENCE_ANCHOR_VALUES = [
  'FROM_ISSUE_DATE',
  'FROM_PREVIOUS_EXPIRY',
  'FROM_COMPLETION',
] as const;
export type RecurrenceAnchorValue = (typeof RECURRENCE_ANCHOR_VALUES)[number];

export const DEADLINE_MAX_WARNING_DAYS_COUNT = 4;
export const DEADLINE_MIN_WARNING_DAY = 1;
export const DEADLINE_MAX_WARNING_DAY = 365;
export const DEFAULT_DEADLINE_WARNING_DAYS = 7;
export const OVERDUE_REMINDER_INTERVAL_DAYS = 7;
export const MAX_RENEWAL_VALIDITY_MONTHS = 120;
export const DEADLINE_TITLE_MAX_LENGTH = 120;
export const DEADLINE_REASON_MAX_LENGTH = 500;
export const DEADLINE_ASSIGNEE_ID_MAX_LENGTH = 100;
/** Tetto della presa in carico: nessuno snooze libero (spec §3.4). */
export const DEADLINE_TAKE_OVER_MAX_DAYS = 90;
export const DEADLINE_TAKE_OVER_NOTE_MAX_LENGTH = 500;
export const DEFAULT_DEADLINES_PAGE_SIZE = 20;
export const MAX_DEADLINES_PAGE_SIZE = 100;

/** Giorno di calendario senza orario (`YYYY-MM-DD`): le scadenze non portano fuso. */
export const ISO_DAY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const DEADLINE_VALUE_SOURCE_VALUES = ['MANUAL', 'CATALOG_DEFAULT', 'BACKFILL'] as const;
export type DeadlineValueSourceValue = (typeof DEADLINE_VALUE_SOURCE_VALUES)[number];
